/* eslint-disable @typescript-eslint/ban-types */
import { InputAdornment } from '@material-ui/core'
import { Brush } from '@material-ui/icons'
import React from 'react'
import {
  renderHelpersText,
  renderErrorInField,
  renderUpdatedInField,
} from '@flatsy/utils/Functions/form/Helpers'
import { validateHexaColor as validateHexaColorUtils } from '@flatsy/utils/Functions/Validators'
import { FieldsType, SingleFieldProps } from '../../../../Types'
import FormTextField from '../../../../../Global/TextField'
import { useStyles } from './Style'
import { renderValue } from './Utils'

const ColorPicker = <T extends {}>({
  field,
  input,
  meta,
  values,
  justSubmitted,
}: SingleFieldProps<T>): React.ReactElement => {
  const classes = useStyles()

  /**
   * @description render label or condition label
   * @param field
   * @param values
   */
  const renderLabelInField = (field: FieldsType, values: T) => {
    return field.conditional ? field.conditional(values).label : field.label
  }

  /**
   * @description event when input change, regex test + add # at the string start
   * @param val
   */
  const onChange = (val: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (!/^[0-9a-f]{0,6}$/i.test(val.target.value)) {
      return
    }
    input.onChange(`#${val.target.value}`)
  }

  /**
   * @description render a react element for the start icon
   */
  const renderStartIcon = (): React.ReactElement => {
    return (
      <>
        <InputAdornment position="start">
          <Brush color="action" />
        </InputAdornment>
        <InputAdornment position="start" className={classes.startIcon}>
          #
        </InputAdornment>
      </>
    )
  }

  /**
   * @description render a react element for the color preview
   */
  const renderColorPreview = (): React.ReactElement => {
    return (
      <>
        <InputAdornment position="end">
          <div
            style={
              input.value && validateHexaColorUtils(input.value)
                ? { backgroundColor: input.value }
                : {}
            }
            className={classes.colorPreview}
          />
        </InputAdornment>
      </>
    )
  }

  return (
    <FormTextField
      error={renderErrorInField(meta)}
      updated={renderUpdatedInField(meta, justSubmitted)}
      helperText={renderHelpersText(field, meta.touched, meta.error, meta.submitError)}
      label={renderLabelInField(field, values)}
      {...input}
      value={renderValue(input)}
      InputProps={{
        startAdornment: renderStartIcon(),
        endAdornment: renderColorPreview(),
      }}
      onChange={onChange}
      fullWidth
    />
  )
}

export default ColorPicker
